import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=63184ee9&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63184ee9')) {
      api.createRecord('63184ee9', component.options)
    } else {
      api.reload('63184ee9', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=63184ee9&", function () {
      api.rerender('63184ee9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/candidates/Main.vue"
export default component.exports